import React from 'react'
import './Slider.css'

const Slider = ({inst, handleVolume}) => {
  return (
    <div className='slider'>
      <input
        type='range'
        className='slideInput verticalSlider'
        defaultValue='80'
        onChange={e => handleVolume(inst, e)}
      />
    </div>
  )
}

export default Slider


// WEBPACK FOOTER //
// ./src/Slider/Slider.js